var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlimitedMydecor = function SvgUnlimitedMydecor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.3367,
    cy: 93.7245,
    r: 10.6633,
    fill: "#E3E6FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.6531,
    cy: 51.6327,
    r: 5.61224,
    fill: "#FFCCB7"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_5236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.721 86.3262L67.153 82.5674C70.0204 79.4269 71.64 75.3847 71.7392 71.1442H75.3C75.3992 75.3846 77.019 79.4268 79.8864 82.5674L83.3183 86.3262C83.9328 86.9993 84.4608 87.726 84.9003 88.4938H62.139C62.5784 87.726 63.1065 86.9993 63.721 86.3262Z",
    fill: "url(#paint0_linear_1112_5236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0232 80.6161C81.6976 80.2594 81.3917 79.8884 81.1051 79.5053C81.5972 78.6969 82.1487 77.9188 82.7516 77.1842L83.5542 76.2063C86.323 72.8328 87.8478 68.5715 87.8478 64.2073V55.5612H91.399V64.2075C91.399 68.5716 92.9238 72.8329 95.6925 76.2065L96.4952 77.1844C99.7246 81.119 101.331 86.084 101.019 91.1647C100.707 96.2453 98.5054 100.977 94.819 104.487L94.3333 104.949H85.0179C87.4705 102.477 89.0074 99.1916 89.3035 95.6904C89.6526 91.5603 88.2499 87.4359 85.4552 84.375L82.0232 80.6161Z",
    fill: "url(#paint1_linear_1112_5236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9581 91.3876H86.081C86.4194 92.6893 86.5374 94.0561 86.4198 95.4465C86.36 96.1537 86.2406 96.8442 86.0657 97.5139H60.9732C60.7985 96.8442 60.6789 96.1537 60.6191 95.4465C60.5017 94.0561 60.6197 92.6893 60.9581 91.3876Z",
    fill: "url(#paint2_linear_1112_5236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8864 100.408C84.1212 101.744 83.0925 102.933 81.831 103.917L80.5067 104.949H66.5324L65.2081 103.917C63.9467 102.933 62.9179 101.744 62.1527 100.408H84.8864Z",
    fill: "url(#paint3_linear_1112_5236)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5236",
    x1: 62.139,
    y1: 71.1442,
    x2: 84.9003,
    y2: 71.1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5236",
    x1: 81.1051,
    y1: 55.5612,
    x2: 101.058,
    y2: 55.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_5236",
    x1: 60.575,
    y1: 91.3876,
    x2: 86.4641,
    y2: 91.3876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1112_5236",
    x1: 62.1527,
    y1: 100.408,
    x2: 84.8864,
    y2: 100.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_5236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.3878,
    height: 49.3878,
    fill: "white",
    transform: "matrix(-1 0 0 1 105.51 55.5612)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlimitedMydecor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlimited-mydecor.a37bae07e576be44f525c2b9c826f25e.svg";